import { ReadonlyURLSearchParams, useSearchParams } from 'next/navigation'
import { useMemo } from 'react'

export const useQueryParams = (): { query: Record<string, string>; searchParams: ReadonlyURLSearchParams | null } => {
  const searchParams = useSearchParams()
  const query = useMemo(() => {
    const result: Record<string, string> = {}
    if (searchParams) {
      for (const [key, value] of searchParams.entries()) {
        result[key] = value
      }
    }
    return result
  }, [searchParams])

  return { query, searchParams }
}
